import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=8b0a24e4&scoped=true&"
var script = {}
import style0 from "./Rules.vue?vue&type=style&index=0&id=8b0a24e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0a24e4",
  null
  
)

export default component.exports